export default "__VITE_ASSET__BVkJUMke__"